import { useTranslation } from "react-i18next";
import { testimonials } from "@/mocks/categories";

export default function Testimonials() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <div className="w-10 h-10 mx-auto mb-3 rounded-lg bg-accent-100 flex items-center justify-center">
            <i className="ri-double-quotes-l text-accent-600 text-lg"></i>
          </div>
          <span className="inline-block px-4 py-1.5 rounded-full border border-accent-300 text-xs font-medium text-accent-700 bg-accent-50 mb-3 whitespace-nowrap">
            {t("testimonials.tag")}
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950">
            {t("testimonials.title")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {testimonials.map((item, idx) => (
            <div
              key={idx}
              className={`rounded-xl p-5 md:p-6 border border-background-200/70 bg-background-50 ${
                idx === 3 ? "lg:col-span-2" : ""
              }`}
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-950">
                    {item.name}
                  </div>
                  <div className="text-xs text-foreground-500">
                    {item.role}
                  </div>
                </div>
              </div>
              <div className="mb-3">
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-double-quotes-l text-accent-300 text-lg"></i>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed">
                {item.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}